module.exports = __webpack_public_path__ + "static/img/icon3.0e1a6344.png";